module.exports = __webpack_public_path__ + "media/img/events/bg/schedule-5f43dc10085066284df7ea0bdf822f03.jpg";